import momentGenerateConfig from './src/generate/moment';
import generatePicker from './generatePicker';
const DatePicker = generatePicker(momentGenerateConfig);
export default DatePicker;
